module.exports = __webpack_public_path__ + "img/1080_13.bb51e116.jpg";